import { Loader } from "@mantine/core";
import {
  IconAlertTriangle,
  IconCircleCheck,
  IconQuestionMark
} from "@tabler/icons-react";
import type { SitePlausibility } from "../../../../../../utils/backend-types";
import { THEME_VARS } from "../../../../../../utils/constants";
import { SiteTitle } from "../../../SiteTitle/SiteTitle";
import "./RawEnergySiteTitle.scss";

interface RawEnergySiteTitleProps {
  loading: boolean;
  sitePlausibilityError: Error | null;
  showPlausibility: boolean;
  siteName: string;
  sitePlausibility: SitePlausibility | undefined;
}

function RawEnergySiteTitle({
  loading,
  sitePlausibilityError,
  showPlausibility,
  siteName,
  sitePlausibility
}: RawEnergySiteTitleProps) {
  const allUnknown = false;

  let TablerIcon = <IconCircleCheck color={THEME_VARS.success[6]} />;
  if (showPlausibility && !allUnknown) {
    if (sitePlausibilityError) {
      TablerIcon = <IconQuestionMark color={THEME_VARS.error[6]} />;
    } else if (sitePlausibility) {
      const isSitePlausible = sitePlausibility.reduce(
        (plausible, meterPlausibility) => {
          return plausible && meterPlausibility.plausibility !== false;
        },
        true
      );

      if (!isSitePlausible) {
        TablerIcon = <IconAlertTriangle color={THEME_VARS.warning[6]} />;
      }
    }
  } else {
    TablerIcon = <></>;
  }

  return (
    <SiteTitle
      icon={loading ? <Loader size="xs" /> : TablerIcon}
      text={siteName}
    />
  );
}

export { RawEnergySiteTitle };
